import React from 'react';
import { calculateAge, formatPhoneNumber } from '@src/utils';
import { useSelector } from 'react-redux';
import { GENDER } from '@src/constants';
import { StyledHeader } from './index.style';

const Header = ({ title, customer = {} }) => {
  const { account } = useSelector((state) => state.auth);
  const logo =
    useSelector((state) => state.theme.logo) || '/environments/logo.png';

  return (
    <StyledHeader>
      <div className="header-print">
        <div className="logo-invoice">
          <img src={logo} alt="logo" />
        </div>
        <div className="address">
          <h4>{account?.facility?.name?.normalize('NFC')?.toUpperCase()}</h4>
          <p>Địa chỉ: {account?.facility?.address?.normalize('NFC')}</p>
          <p>Hotline: {formatPhoneNumber(account?.facility?.phoneNumber)}</p>
          {account?.facility?.email && <p>Email: {account?.facility?.email}</p>}
        </div>
      </div>
      <hr className="divider" />
      <h5 className="title-print">{title}</h5>
      <div className="customer-info">
        <div>
          Họ tên: <strong>{customer.name}</strong>
        </div>
        <div>
          Giới tính: <strong>{GENDER[customer.gender]}</strong>
        </div>
        <div>
          Tuổi: <strong>{calculateAge(customer.birthday)}</strong>
        </div>
        <div className="nowrap">
          SĐT: <strong>{customer.phoneNumber}</strong>
        </div>
        <div className="address-line">
          Địa chỉ: <strong>{customer.address}</strong>
        </div>
      </div>
    </StyledHeader>
  );
};

export default Header;
